import { Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { Spinner } from "../external/ensolvers-core-frontend-mui/components/Common/Spinner";
import { ColorUtils } from "../utils/ColorUtils";
import { SwitchCustom } from "../utils/SwitchCustom";
import { ButtonComponent } from "./ButtonComponent";

interface ButtonLabel {
  label: string;
  onClick: () => void;
}

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  content: JSX.Element;
  buttons?: ButtonLabel[];
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  hideCancel?: boolean;
  isLoading?: boolean;
  toggle?: boolean;
  setActive?: Dispatch<SetStateAction<boolean>>;
  active?: boolean;
}

export const AppDialog = ({
  open,
  onClose,
  title,
  content,
  buttons,
  maxWidth,
  hideCancel = false,
  isLoading,
  toggle,
  setActive,
  active,
}: Props) => {
  const theme = useTheme();

  const handleChangeActivePositions = () => {
    setActive?.(!active);
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth}>
      {isLoading ? (
        <>
          <Grid sx={{ minWidth: "46.3em", height: "13.1em" }}>
            <Spinner />
          </Grid>
        </>
      ) : (
        <>
          <Grid display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
            <DialogTitle style={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}>{title}</DialogTitle>
            {toggle && (
              <Grid display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
                <SwitchCustom checked={active} onChange={handleChangeActivePositions} size="medium" color="primary" />
                <Typography variant="body1">Active Positions Only</Typography>
              </Grid>
            )}
          </Grid>

          <DialogContent>{content}</DialogContent>

          <DialogActions>
            {!hideCancel && <ButtonComponent onClick={onClose} text={"Cancel"} />}

            {buttons?.map((button, index) => (
              <ButtonComponent
                key={`${button.label}-${index}`}
                debounce
                onClick={button.onClick}
                text={button.label}
                style={{ color: ColorUtils.BTN_TEXT_CONFIRM }}
              />
            ))}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
